module.exports = __webpack_public_path__ + "img/autoplayboothvideo.73f777df.png";